import debounce from 'lodash.debounce';
import checkStatus from '../../utils/checkStatus';
import { contains, merge } from 'ramda';

const getCompanies = debounce((companyName, companyType, country, dispatch) => {
  dispatch({ type: 'UPDATE_TYPE_AHEAD_COMPANIES_STARTED' })
  return fetch(`/proxy/contractingSignUp/getCompanies/${companyName}?companyType=${companyType}&country=${country}`)
  .then(res => res.json())
  .then(res => {
    return dispatch({ type: 'UPDATE_TYPE_AHEAD_COMPANIES', payload: res });
  })
  .catch(res => {
    dispatch({ type: 'COMPANY_EXISTS' });
    throw new Error(res.message);
  });
}, 400);

export const updateCompanyForContractingSignUp = (value) => (dispatch, getState) => {
  const { companyType, country } = getState().contractingSignUp.toJS();
  dispatch({ type: 'UPDATE_CONTRACTING_SIGN_UP_COMPANY', payload: value });
  if (value && value.length > 2) getCompanies(value, companyType, country, dispatch);
}

export function decryptEmail(emailField) {
  return dispatch => {
    const isEmailNotEncrypted = contains('@', emailField);
    return fetch(`/proxy/decryptEmail/${emailField}`)
      .then(checkStatus)
      .then(res => res.json())
      .then(res => dispatch({ type: 'DECRYPT_EMAIL_SUCCESS', payload: merge(res, { isEmailNotEncrypted, loading: false }) }))
      .catch(() => dispatch({ type: 'DECRYPT_EMAIL_FAILED' }));
  };
}

export function getExternalContractingDocs(emailField, companyType) {
  return dispatch => {
    return fetch(`/proxy/email/contracts/${emailField}?companyType=${companyType}`)
    .then(checkStatus)
    .then(res => res.json())
    .then(res => dispatch({ type: 'GET_EXTERNAL_CONTRACTING_DOCS_SUCCESS', payload: res }));
  };
}

export const sendUpdatedLink = (email) => (dispatch, getState) => {
  const companyType = getState().contractingSignUp.toJS().companyType;
  dispatch({ type: 'UPDATE_PROPS_FOR_SHELL_ACCOUNT_SIGNUP', payload: { loading: true } });
  return fetch(`/proxy/sendNewShellAccountInvite/${email}?companyType=${companyType}`)
  .then(checkStatus)
  .then(() => dispatch({ type: 'UPDATE_PROPS_FOR_SHELL_ACCOUNT_SIGNUP', payload: { loading: false, emailSent: true } }))
  .catch(() => dispatch({ type: 'UPDATE_PROPS_FOR_SHELL_ACCOUNT_SIGNUP', payload: { loading: false, sendingEmailError: true } }));
}

export function submitContractingSignUp() {
  return (dispatch, getState) => {
    dispatch({ type: 'CONTRACTING_SIGNUP_START' });
    const state = getState().contractingSignUp.toJS();
    // const credentials = {
    //   email,
    //   password,
    //   country,
    //   companyName,
    //   companyId,
    //   companyType,
    //   productType: this.props.contractingSignUp.get('productType'),
    //   oneOrMulti: this.props.contractingSignUp.get('oneOrMulti'),
    // }
    return fetch('/contractingSignUp/signUp', {
      method: 'post',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(state),
    })
    .then(res => res.json())
    .then(response => {
      if (response.error) return dispatch({ type: 'CONTRACTING_SIGNUP_FAILED', payload: response });
      return dispatch({ type: 'CONTRACTING_SIGNUP_SUCCESS' });
    })
    .catch(err => {
      console.log(err);
      dispatch({ type: 'CONTRACTING_SIGNUP_FAILED' });
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/stores/contracting-sign-up/actions.js